/**
 * Since we need to flatten our inputs in our data layer to ensure that
 * validation works out of the box, then we need to expand our content again
 * into rows with relevant inputs.
 */
function transformInputsToRelativePositions(content, backgroundImg) {
  if (!backgroundImg) {
    return undefined;
  }
  return content.map(input => ({
    ...input,
    placement: {
      ...input.placement,
      x: input.placement.x / backgroundImg.naturalWidth,
      y: input.placement.y / backgroundImg.naturalHeight
    }
  })).sort((a, b) => {
    if (a.placement.y < b.placement.y) {
      return -1;
    }
    if (b.placement.y < a.placement.y) {
      return 1;
    }
    if (a.placement.x < b.placement.x) {
      return -1;
    }
    if (b.placement.x < a.placement.x) {
      return 1;
    }
    return 0;
  });
}

export { transformInputsToRelativePositions };
//# sourceMappingURL=util.transform-to-relative-positions.js.map
